export default {
    namespaced: true,
    state: {
        loggedin: false
    },
    getters: {
        loggedin (state) {
            return state.loggedin
        }
    },

    mutations: {
        loggedin (state, loggedin) {
            state.loggedin = loggedin
        }
    },
    actions: {}
}
